import { render, staticRenderFns } from "./TipoTalhao.vue?vue&type=template&id=dffda770"
import script from "./TipoTalhao.vue?vue&type=script&lang=js"
export * from "./TipoTalhao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports